module.exports = __webpack_public_path__ + "img/delivery.18de3943.jpg";